import { API_BASE_URL } from './client'

/**
 * Adresses de la documentation publique des intégrations, servie par le
 * BACKEND (`/docs`, `/llms.txt`) et non par ce SPA : elle se lit sans
 * JavaScript, et ses références viennent des registres que seul le backend
 * connaît. L'écran « Développeurs » n'en garde AUCUNE copie : il y renvoie.
 *
 * Origine de l'API, pas `window.location` : en développement, le SPA et
 * l'API ne vivent pas sur la même origine.
 */
const origine = new URL(API_BASE_URL, window.location.origin).origin

export const DOCUMENTATION = {
  accueil: `${origine}/docs`,
  api: `${origine}/docs/api`,
  apiMarkdown: `${origine}/docs/api.md`,
  mcp: `${origine}/docs/mcp`,
  mcpMarkdown: `${origine}/docs/mcp.md`,
  openapi: `${origine}/v1/openapi.json`,
  llms: `${origine}/llms.txt`,
} as const
